import { render, staticRenderFns } from "./TelegramQRIntegrationsModal.vue?vue&type=template&id=354b2811"
import script from "./TelegramQRIntegrationsModal.vue?vue&type=script&lang=js"
export * from "./TelegramQRIntegrationsModal.vue?vue&type=script&lang=js"
import style0 from "./TelegramQRIntegrationsModal.vue?vue&type=style&index=0&id=354b2811&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports